var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPagination({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_1733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1857 2.73715C11.3438 2.89526 11.4229 3.08245 11.4229 3.29874C11.4229 3.5146 11.3438 3.70158 11.1857 3.85968L6.55329 8.49209L11.2015 13.1403C11.3491 13.2879 11.4229 13.4723 11.4229 13.6937C11.4229 13.915 11.3438 14.1047 11.1857 14.2628C11.0276 14.4209 10.8404 14.5 10.6241 14.5C10.4083 14.5 10.2213 14.4209 10.0632 14.2628L4.75091 8.93478C4.68767 8.87154 4.64277 8.80303 4.61621 8.72925C4.59007 8.65547 4.577 8.57642 4.577 8.49209C4.577 8.40777 4.59007 8.32872 4.61621 8.25494C4.64277 8.18116 4.68767 8.11265 4.75091 8.04941L10.079 2.72134C10.2265 2.57378 10.4083 2.5 10.6241 2.5C10.8404 2.5 11.0276 2.57905 11.1857 2.73715Z",
    fill: "#002466"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_1733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPagination);
export default __webpack_public_path__ + "static/media/previous_pagination.8f1da10ac7642db58902c4ee8a3a0aec.svg";
export { ForwardRef as ReactComponent };